<template>
  <div class="ProductFormats">
    <div 
      v-for="format in formats"
      class="ProductFormats__format"
      :class="{'selected': isOptionSelected(format)}"
      :style="extraStyle(format)"
      :key="format.CODFORMATO"
      @click="onSelectFormat(format)"
    >
      <div class="ProductFormats__format__description">{{format.DESCRIPCION}}</div>
      <span class="badge badge-warning ProductFormats__format__price" v-if="showInc(format)"
      >{{incPrecio(format)}}</span>
      <span class="badge badge-success ProductFormats__format__selected" v-if="isOptionSelected(format)"
      ><i class="fa fa-check"/></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    formats: { type: Array, required: true },
    selected: { type: Object }
  },
  created() {
    if (this.formats === 1) this.selected = this.formats[0]
  },
  methods: {
    isOptionSelected(format) {
      const formats = Object.values(this.formats)
      if (formats.length === 1) {
        this.onSelectFormat(formats[0])
      } else if (!this.selected.CODFORMATO && formats.length > 1) {
        this.onSelectFormat(formats[0])
      }
      return this.selected && this.selected.CODFORMATO === format.CODFORMATO
    },
    onSelectFormat(format) {
      this.$emit('formatSelected', format)
    },
    showInc(format) {
      const inc = Number(format.PVP)
      return inc !== 0
    },
    incPrecio(format) {
      let inc = Number(format.PVP)
      return `${inc.toFixed(2)}€`
    },
    extraStyle(format) {
      const colorFondo = '#' + this.getColor(Number(format.COLORFONDO))
      const colorTexto = '#' + this.getColor(Number(format.COLORTEXTO))
      if (colorFondo === '#000000' && colorTexto === '#000000') return null
      return {
        backgroundColor: colorFondo,
        color: colorTexto
      }
    },
    getColor: int => {
      let red = int >> 16
      let green = (int - (red << 16)) >> 8
      let blue = int - (red << 16) - (green << 8)
      let bin = (blue << 16) | (green << 8) | red
      return (function(h) {
        return new Array(7 - h.length).join('0') + h
      })(bin.toString(16).toUpperCase())
    }
  }
}
</script>

<style lang="scss">
.ProductFormats {
  display: flex;

  &__format {
    align-items: flex-end;
    background-color: white;
    border: 0.2rem solid transparent;
    border-radius: 0.4rem;
    display: flex;
    flex: 1;
    height: 5rem;
    justify-content: center;
    user-select: none !important;
    padding: 0.4rem;
    margin: 0 0.4rem;
    text-align: center;
    position: relative;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    &.selected {
      border: 0.2rem solid #309930;

      .badge {
        font-weight: bold;
      }
    }

    &__description {
      font-size: 0.8rem;
      font-weight: bold;
      text-transform: uppercase;
    }

    &__price {
      position: absolute;
      top: 0.25rem;
      right: 0.25rem;
      font-weight: normal;
    }

    &__selected {
      position: absolute;
      top: 0.25rem;
      left: 0.25rem;
      font-weight: normal;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Products/ProductFormats.vue